/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewValuationAllocationVersion } from '../models/NewValuationAllocationVersion';
import type { ValuationAllocationModel } from '../models/ValuationAllocationModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ValuationAllocationService {
    /**
     * @param alId
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationRead(
        alId: string,
    ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/valuation-allocation/{al_id}',
            path: {
                'al_id': alId,
            },
        });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationUpdate(
        alId: string,
        data: ValuationAllocationModel,
    ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/valuation-allocation/{al_id}',
            path: {
                'al_id': alId,
            },
            body: data,
        });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationPartialUpdate(
        alId: string,
        data: ValuationAllocationModel,
    ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/valuation-allocation/{al_id}',
            path: {
                'al_id': alId,
            },
            body: data,
        });
    }
    /**
     * @param alId
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionRead(
        alId: string,
    ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/valuation-allocation/{al_id}/new-version',
            path: {
                'al_id': alId,
            },
        });
    }
    /**
     * @param alId
     * @param data
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionUpdate(
        alId: string,
        data: NewValuationAllocationVersion,
    ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/valuation-allocation/{al_id}/new-version',
            path: {
                'al_id': alId,
            },
            body: data,
        });
    }
    /**
     * @param alId
     * @param data
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionPartialUpdate(
        alId: string,
        data: NewValuationAllocationVersion,
    ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/valuation-allocation/{al_id}/new-version',
            path: {
                'al_id': alId,
            },
            body: data,
        });
    }
}
